var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wscn-http404"},[_c('div',{staticClass:"bullshit"},[_c('img',{attrs:{"src":_vm.img_404,"alt":"404"}}),_c('div',{staticClass:"bullshit__headline"},[_vm._v("你没有相应的管理后台权限，请联系数据产品部")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }